import configuration from 'globalConfiguration';

var pluginName = 'TabIndexer',
	options = {
		indexArea: configuration.global.contentArea,
		removeLinkTabs: configuration.global.removeLinkTabs,
		indexSelector: 'input:not([type=hidden]):not([type=file]), textarea, select, .defaultLink, .formSubmit, ' + configuration.global.ckeditorSelector + ':not([readonly])',
		removeSelector: '.defaultLink',
	};

function TabIndexer(element, opts) {

	this.options = $.extend(true, {}, options, opts);
	this.element = element;

	this.addEventListeners();
}

TabIndexer.prototype.addEventListeners = function () {
	$(document)
		.on('ajaxPageLoaded', $.proxy(this.indexInputs, this));
};

TabIndexer.prototype.indexInputs = function () {
	var area = document.querySelector(this.options.indexArea);
	if (area) {
		var inputs = area.querySelectorAll(this.options.indexSelector);
		for (var i = 0; i < inputs.length; i++) {
			if (this.options.removeLinkTabs) {
				var tabIndex = 0;
			} else {
				var tabIndex = i + 1;
			}
			if ($(inputs[i])
				.attr('tabindex') != '-1') {
				$(inputs[i])
					.attr('tabindex', tabIndex);
			}
		}
		if (this.options.removeLinkTabs) {
			var links = area.querySelectorAll(this.options.removeSelector);
			for (var i = 0; i < links.length; i++) {
				var isdescription = $(links[i])
					.parents('.templatedescription');
				if (isdescription.length > 0) {
					$(links[i])
						.attr('tabindex', '-1');
				}
			}
		}
	}
};

$.fn[pluginName] = function (options) {
	return new TabIndexer(this, options);
};
